import { useAppSelector } from ".";

export default function useSuggestions() {
  const { data, ...suggestionsState } = useAppSelector((state) => state.suggestions);
  return {
    suggestions: data,
    ...suggestionsState,
  };
}
